const language = store => next => action => {
    if (action.type && action.type === 'SAVE_LANGUAGE') {
        localStorage.setItem('language', JSON.stringify(store.getState().language))
    }

    next(action)
};

export default language;
